<template>
  <div class="nav-loading">
    <div class="nav-loading-top">
      <div class="nav-loading-top-left" />
      <div class="nav-loading-top-right" />
    </div>
    <div class="nav-loading-bottom" />
  </div>
</template>

<style lang="scss" scoped>
.nav-loading {
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0 16px;
  width: 100%;
  height: 166px;
}
.nav-loading-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  height: 98px;
  .nav-loading-top-left,
  .nav-loading-top-right {
    border-radius: 8px;
    width: 138px;
    height: 98px;
    background-color: rgba(255,255,255,0.1);
  }
}
.nav-loading-bottom {
  border-radius: 8px;
  width: 100%;
  height: 40px;
  background-color: rgba(255,255,255,0.1);
}
</style>
